import publisherLogos from "../../img/listings-publishers.png";
import "./ListingsSplash.scss";

interface Props {
  onCta: () => void;
  ctaLabel?: string;
  // Footer under the CTA: defaults to the "See pricing plans" link; pass a node to override
  // (e.g. the "$60/month per location · Cancel anytime" fine print in the onboarding flow).
  footer?: React.ReactNode;
  pricingUrl?: string;
}

export function ListingsSplash({
  onCta,
  ctaLabel = "Add Business Listings",
  footer,
  pricingUrl = "/menu/pricing.do",
}: Props) {
  return (
    <div className="listings-splash">
      <img
        className="listings-splash-logos"
        src={publisherLogos}
        alt="Facebook, Yelp, Google, Instagram, Uber Eats, Apple Maps, TripAdvisor, DoorDash, OpenTable"
      />

      <h2 className="listings-splash-title">Your menu, everywhere it matters.</h2>
      <p className="listings-splash-subtitle">
        MustHaveMenus now syncs your menu data to Google, Yelp, Apple Maps, TripAdvisor, and more —
        automatically. One source of truth, zero manual updates.
      </p>

      <button type="button" className="listings-splash-cta" onClick={onCta}>
        {ctaLabel}
      </button>

      {footer ?? (
        <a className="listings-splash-pricing" href={pricingUrl}>
          See pricing plans
        </a>
      )}
    </div>
  );
}
